import { colors, screenSizes } from "@storeblocks/global-styles";
import styled, { createGlobalStyle } from "styled-components";

interface ButtonIconProps {
  textPosition: "left" | "right"; // Which side is the button text on.
}

export const ButtonIcon = styled.div<ButtonIconProps>`
  fill: ${colors.green.green50};
  margin-left: ${(props) => (props.textPosition === "left" ? "8px" : "0px")};
  margin-right: ${(props) => (props.textPosition === "right" ? "8px" : "0px")};
  max-height: 15px;
  max-width: 15px;
`;

export const CenterContentContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const NotificationBadge = styled.span`
  background-color: red;
  border-radius: 4px;
  padding: 5px 5px;
  position: absolute;
  right: -4px;
  top: -4px;
`;

export const PageHeader = styled.div`
  border-bottom: 1px solid lightgray;
  margin-bottom: 48px;
  padding: 12px 0px 12px 0px;

  h1 {
    font-size: 32px;
  }

  @media only screen and (max-width: ${screenSizes.desktop}px) {
    margin-bottom: 24px;
    padding: 0px 0px 24px 0px;
  }
`;

export const SpinnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 24px;
  width: 100%;
`;

export const SpanBolder = styled.span`
  font-weight: bolder;
`;

export const SpinnerText = styled.p`
  margin-top: 16px;
`;

export const StyledIconContainer = styled.div`
  svg {
    height: 150px;
  }

  @media only screen and (max-width: ${screenSizes.desktop}px) {
    padding: 28px 0px;
    text-align: center;

    svg {
      height: 69px;
    }
  }
`;

export const SubHeader = styled.h2``;

export const TemporaryImplementationWarning = styled.p`
  color: red;
  font-weight: bold;
`;

export const ApplicationGlobalStyle = createGlobalStyle`
  html {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100%;
  }

  body {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
    height: 100%;
    padding-top: 0;
  }

  body > #root {
    display: flex;
    flex: 1 0 auto;
    flex-direction: column;
  }
`;

/**
 * Global style to control focus outlines.
 * Is enabled/disabled through component FocusOutlineHandler.
 */

export const FocusOutlineStyle = createGlobalStyle`
 body.using-mouse :focus {
     outline: none !important;
 }

 body.using-mouse li {
     outline: none !important;
 }
 i {
    font-family: 'System-Icons' !important;
  }
`;
